import { AfterViewInit, Directive, ElementRef } from '@angular/core';

/**
 * Focuses the host element when it enters the view. Unlike the native
 * `autofocus` attribute (which only fires on initial page load), this works for
 * elements inserted dynamically via *ngIf — e.g. the qualification panel's
 * inline "+ Add" input, which should be ready to type in the moment it appears.
 */
@Directive({
    selector: '[mapsAutofocus]',
    standalone: false,
})
export class AutofocusDirective implements AfterViewInit {
    constructor(private readonly el: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        this.el.nativeElement.focus();
    }
}
